// src/utils/speechText.js
// Was von einem Text vorgelesen wird. Ohne Importe halten: scripts/tts/build-audio.js liest
// diese Datei direkt, damit App und Vertonungs-Skript denselben Text (und damit dieselbe
// Audiodatei) verwenden.

/**
 * Macht aus dem Kartentext das, was vorgelesen werden soll:
 * "malo/a" -> "malo", "léger/légère" -> "léger", "le tien/la tienne" -> "le tien",
 * Hinweise in Klammern ("Saft (Spanien)") fallen weg.
 */
export function textForSpeech(text) {
  return String(text || "")
    .replace(/\([^)]*\)/g, "")
    .replace(/\/(?:le|la|les) .*$/i, "")
    .replace(/\/\p{L}+/gu, "")
    .replace(/\s+/g, " ")
    .trim()
    .normalize("NFC");
}

/**
 * Dateiname der vorab vertonten Audiodatei zu einem aufbereiteten Text (14 Hex-Zeichen).
 * Absichtlich synchron (53-Bit-Prüfsumme „cyrb53“ statt crypto.subtle): iOS Safari spielt
 * Ton nur ab, wenn play() direkt im Tipp-Ereignis aufgerufen wird, ohne await davor.
 */
export function audioKey(text) {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < text.length; i++) {
    const ch = text.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16).padStart(14, "0");
}

// "h aspiré": kein j' davor (je hais, je heurte)
const FRENCH_H_ASPIRE = /^(ha[iï]|heurt)/i;

/** Wird "je" vor diesem Wort zu "j'" (Vokal oder stummes h: j'ai, j'habite, aber je hais)? */
export function frenchElidesBefore(word) {
  const w = String(word || "").trim();
  return /^[aeiouyàâäéèêëîïôöùûüœh]/i.test(w) && !FRENCH_H_ASPIRE.test(w);
}

// Subjektpronomen zum Vorlesen französischer Verbformen ("ai" allein klingt nach nichts).
const FRENCH_SPEECH_PRONOUNS = { "1s": "je", "2s": "tu", "3s": "il", "1p": "nous", "2p": "vous", "3p": "ils" };

/**
 * Was bei einer Verbform vorgelesen wird: Spanisch die Form allein ("tengo"), Französisch mit
 * Subjektpronomen ("j'ai", "il pleut"), im Imperativ ohne ("viens").
 */
export function verbFormForSpeech(form, lang, slot, tense) {
  const text = String(form || "").trim();
  if (lang !== "fr" || tense === "imperative" || !text || text === "-") return text;
  if (slot === "1s" && frenchElidesBefore(text)) return `j'${text}`;
  const pronoun = FRENCH_SPEECH_PRONOUNS[slot];
  return pronoun ? `${pronoun} ${text}` : text;
}
